export enum SeasonGroup {
  Current,
  Previous,
}
